import React from 'react';

const NotificationType = props => {
  const { notificationLogo, notificationText, setNotification, handleNotification } = props;
  const clickedOnToggle = () => {
    handleNotification();
  };
  return (
    <div className="notificationBlock mr-t20" data-testid="notificationContainer">
      <label
        className="toggle-style display-flex justify-content-space-between"
        htmlFor="toggleStatus"
        onClick={() => clickedOnToggle()}
      >
        <div>
          <div className="inline-block notification-logo">
            <img
              alt="notificationImage"
              src={`https://static1.lenskart.com/media/desktop/img/June23/${notificationLogo}.svg`}
            />
          </div>
          <span className="fw400 fsp14">{notificationText}</span>
        </div>
        <div className="switch inline-block cursor-pointer">
          <div
            className={`${setNotification ? 'active' : ''} block toggleswitch`}
            data-testid="switch"
            id="toggleStatus"
          >
            <span className="block handle"></span>
          </div>
        </div>
      </label>
    </div>
  );
};

export default NotificationType;
